export default __webpack_public_path__ + "images/35fd43f15f89576fe6dfa2545fa4396a.png";